export default "__VITE_ASSET__090037be__"